"use strict";
import { Interface } from "@ethersproject/abi";
import { NEVER_RELOAD, useMultipleContractSingleData } from "lib/hooks/multicall";
import ERC20ABI from "uniswap/src/abis/erc20.json";
const ERC20Interface = new Interface(ERC20ABI);
export function useTokenContractsConstant(tokens, field) {
  return useMultipleContractSingleData(tokens, ERC20Interface, field, void 0, NEVER_RELOAD);
}
